import React from 'react';
import { useTranslation } from 'react-i18next';
import { UserProfile } from '../../../../../model/user/profile/UserProfile';

const SUPPORT_EMAIL = 'contato@getservice.io';

type MyAccountProps = {
    profileData: UserProfile | null;
};

/**
 * Deactivating or deleting an account has heavy consequences (businesses,
 * appointments, payment history), so it's handled BY SUPPORT, not by a
 * self-service button — this screen routes the user to CS with a pre-filled
 * email instead.
 */
const MyAccountComponent: React.FC<MyAccountProps> = ({ profileData }) => {
    const { t } = useTranslation();

    const mailto = (subjectKey: string) => {
        const subject = encodeURIComponent(t(subjectKey));
        const body = encodeURIComponent(t('settings.profile.account.mailBody', {
            email: profileData?.email ?? '',
        }));
        return `mailto:${SUPPORT_EMAIL}?subject=${subject}&body=${body}`;
    };

    return (
        <div className="side-content-vertical">
            <div className="profile-section-container separated-container">
                <h3 className="section-header">{t('settings.profile.account.sectionTitle')}</h3>
                <p className="text-muted">{t('settings.profile.account.contactHint')}</p>
                <div className="form-row">
                    <div className="form-group">
                        <label>{t('settings.profile.account.deactivateLabel')}</label>
                        <div>
                            <a
                                className="btn btn-outline-danger"
                                href={mailto('settings.profile.account.deactivateSubject')}
                                data-cy="profile-account-deactivate-btn"
                            >
                                {t('settings.profile.account.contactCs')}
                            </a>
                        </div>
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-group">
                        <label>{t('settings.profile.account.deleteLabel')}</label>
                        <div>
                            <a
                                className="btn btn-outline-danger"
                                href={mailto('settings.profile.account.deleteSubject')}
                                data-cy="profile-account-delete-btn"
                            >
                                {t('settings.profile.account.contactCs')}
                            </a>
                        </div>
                    </div>
                </div>
                <p className="text-muted" style={{ fontSize: '0.85rem' }}>
                    {t('settings.profile.account.supportEmailLabel')}{' '}
                    <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
                </p>
            </div>
        </div>
    );
};

export default MyAccountComponent;
